"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _AbstractCallout = _interopRequireDefault(require("./AbstractCallout"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: stretch;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.partnerReliefCallout." + key;
};

var StyledLink = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_UILink.default, (0, _extends2.default)({}, props, {
    iconProps: {
      style: {
        display: 'none'
      }
    },
    use: "unstyled"
  }));
}).withConfig({
  displayName: "PartnerReliefCallout__StyledLink",
  componentId: "sc-6ur3h4-0"
})(_templateObject());

var PartnerReliefCallout = function PartnerReliefCallout(props) {
  return _react.default.createElement(StyledLink, {
    external: true,
    href: "https://www.hubspot.com/partners/app/relief-efforts"
  }, _react.default.createElement(_AbstractCallout.default, (0, _extends2.default)({}, props, {
    className: "m-bottom-0",
    footer: _react.default.createElement(_UIButton.default, {
      external: true,
      iconProps: {
        color: _colors.OLAF
      },
      size: "extra-small",
      truncate: true,
      use: "tertiary"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('ctaButtonText')
    })),
    illustrationName: "global",
    primaryBackgroundColor: _colors.CALYPSO,
    secondaryBackgroundColor: _colors.OZ,
    subheader: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('subheadingText')
    }),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('titleText')
    })
  })));
};

var _default = PartnerReliefCallout;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/callouts/PartnerReliefCallout.js
// module id = 897
// module chunks = 209 210 211 212